import { Lock, Coins, ShoppingBag } from 'lucide-react';
import { Card } from './Card';
import type { RedemptionGateStatus } from '@core/api/users';

interface RedemptionGateBannerProps {
  gateStatus: RedemptionGateStatus;
}

function ProgressBar({ current, required, percent }: { current: number; required: number; percent: number }) {
  return (
    <div className="space-y-1">
      <div className="flex justify-between text-xs text-text-muted">
        <span>{current} / {required}</span>
        <span>{percent}%</span>
      </div>
      <div className="h-2 bg-secondary/20 rounded-full overflow-hidden">
        <div
          className="h-full bg-amber-500 transition-all duration-500 rounded-full"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}

export function RedemptionGateBanner({ gateStatus }: RedemptionGateBannerProps) {
  if (!gateStatus.gateEnabled || gateStatus.allowed) {
    return null;
  }

  const { progress } = gateStatus;

  return (
    <Card className="bg-amber-500/10 border-amber-500/30">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
          <Lock className="w-5 h-5 text-amber-500" />
        </div>
        <div className="flex-1 space-y-3">
          <div>
            <div className="font-semibold text-text-main text-sm">Списание пока недоступно</div>
            {gateStatus.reason && (
              <div className="text-xs text-text-muted mt-0.5">{gateStatus.reason}</div>
            )}
          </div>

          {progress?.points && !progress.points.met && (
            <div className="space-y-1">
              <div className="flex items-center gap-1.5 text-xs font-medium text-text-main">
                <Coins className="w-3.5 h-3.5 text-amber-500" />
                Баллы
              </div>
              <ProgressBar
                current={progress.points.current}
                required={progress.points.required}
                percent={progress.points.percent}
              />
            </div>
          )}

          {progress?.purchases && !progress.purchases.met && (
            <div className="space-y-1">
              <div className="flex items-center gap-1.5 text-xs font-medium text-text-main">
                <ShoppingBag className="w-3.5 h-3.5 text-amber-500" />
                Покупки
              </div>
              <ProgressBar
                current={progress.purchases.current}
                required={progress.purchases.required}
                percent={progress.purchases.percent}
              />
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}
